import { createSlice } from '@reduxjs/toolkit';

interface IState {
  content: JSX.Element;
  isVisible: boolean;
  isClosingTransition: boolean;
  direction: string;
}

const initialState: IState = {
  content: null,
  isVisible: false,
  isClosingTransition: false,
  direction: 'bottomCenter',
};

const toast = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    createToast: (state, action) => {
      state.content = action.payload;
    },
    isVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setClosingTransition: (state, action) => {
      state.isClosingTransition = action.payload;
    },
    setDirection: (state, action) => {
      state.direction = action.payload;
    },
  },
});

export const { createToast, isVisible, setClosingTransition, setDirection } = toast.actions;
export default toast.reducer;
